import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, UrlTree } from '@angular/router';
import { ApiCommunicationService } from './src/app/services/api-communication.service';

export interface Persona {
  user_role: string;
}

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  private readonly publicRoutes: string[] = ['/login'];
  private readonly dealerRoutes: string[] = ['/core-list', '/core-def-check/:prolife_sr_no', '/pdf-summary', '/notifications'];
  private readonly distRoutes: string[] = ['/distributor-list', '/notifications'];
  private readonly l1Routes: string[] = ['/l1-core-list', '/l1-image-approval/:prolife_sr_no', '/notifications'];
  private readonly technicianRoutes: string[] = ['/technician-list', '/technician-cdc/:prolife_serial_number', '/pdf-summary', '/notifications'];
  private readonly plantRoutes: string[] = [
    '/plant-core-list',
    '/tml-listing/:index',
    '/pdf-summary',
    '/notifications',
    '/core-def-check/:prolife_sr_not',
    '/distributor-list',
  ];

  persona: Persona = {
    user_role: '',
  };

  constructor(
    private readonly router: Router,
    private readonly apiService: ApiCommunicationService
  ) { }

  isLoggedIn(): boolean {
    const token = localStorage.getItem('auth_token');
    return !!token;
  }

  // private checkAccess(url: string): boolean | UrlTree {
  //   if (this.publicRoutes.includes(url)) return true;
  //   if (this.isLoggedIn()) return true;
  //   return this.router.createUrlTree(['/login']);
  // }

  private checkAccess(url: string): boolean | UrlTree {
    const personaResult = this.apiService.getPersona();
    const token = localStorage.getItem('auth_token');
    const persona = localStorage.getItem('userPersona');
    if (token && persona) {
      if (personaResult && typeof personaResult === 'object' && 'user_role' in personaResult) {
        this.persona = personaResult as Persona;
      } else {
        this.persona = { user_role: '' };
        return true;
      }
      switch (this.persona.user_role) {
        case 'Dealer':
          if (this.matchRoute(this.dealerRoutes, url)) return true;
          break;
        case 'Distributor':
          if (this.matchRoute(this.distRoutes, url)) return true;
          break;
        case 'L1 team':
          if (this.matchRoute(this.l1Routes, url)) return true;
          break;
        case 'TML-Technician':
          if (this.matchRoute(this.technicianRoutes, url)) return true;
          break;
        case 'TML-Plant':
          if (this.matchRoute(this.plantRoutes, url)) return true;
          break;
      }
    } else {
      localStorage.clear();
    }
    return this.router.createUrlTree(['/login']);
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
    return this.checkAccess(state.url);
  }

  canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
    return this.checkAccess(state.url);
  }

  private matchRoute(routePatterns: string[], url: string): boolean {
    const cleanUrl = url.split('?')[0];
    const urlParts = cleanUrl.split('/').filter(Boolean);
    return routePatterns.some(pattern => {
      const patternParts = pattern.split('/').filter(Boolean);
      if (patternParts.length !== urlParts.length) return false;
      return patternParts.every((part, idx) => part.startsWith(':') || part === urlParts[idx]);
    });
  }
}
